import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import * as _ from "lodash";
import { ObjectNames } from "../../constants/object.names";
import { SOChannel } from "src/app/inventory/sales-order/constants/constants";
import { ProductSelectionService } from "../../services/product-selection.service";
import { ProductDataService } from "../../services/product-data.service";
import { IProduct } from "./models/product-list.model";
import { ImportserialService } from "../../services/importserial.service";
import { IReportsFilterModel } from "src/app/reports/models/reports-filter.models";
@Component({
    selector: "app-product-selection-modal",
    templateUrl: "./product-selection-modal.component.html",
    styleUrls: ["./product-selection-modal.component.scss"],
})
export class ProductSelectionModalComponent implements OnInit,OnChanges {
    @Input() displayProductSelectionModal;
    @Input() moduleName;
    @Input() headerText;
    @Input() selectedProductsList;
    @Input() isVisibleLocation;
    @Input() isVisibleFilter;
    @Input() selectDefaultLocation: boolean = false;
    @Input() selectedLocationId;
    @Input() type: string = "DEFAULT";
    @Input() selectedAccountId;
    @Input() pricebookConfig: boolean = false;
    @Input() selectionMode: 'multiple'|'single' = 'multiple';
    @Input() baseCurrency: any;
    @Input() currencyExchangeRate: any;
    @Input() currencyUnit: any;

    @Output() onCancelClicked = new EventEmitter();
    @Output() onProductAddComplete = new EventEmitter();
    @Output() onLocationSelect = new EventEmitter();
    @ViewChild("globalSearchInput", { static: true })
    globalSearchInput: ElementRef;

    productCols = [
        {
            field: "id",
            header: "ID",
            show: false,
            checked: false,
            fieldDataType: "number",
        },
        {
            field: "itemNo",
            header: "Item No.",
            show: true,
            checked: true,
            fieldDataType: "string",
        },
        {
            field: "hsnsac",
            header: "HSN Code.",
            show: true,
            checked: true,
            fieldDataType: "string",
        },
        {
            field: "description",
            header: "Item Desc",
            show: true,
            checked: true,
            fieldDataType: "string",
        },
        {
            field: "availabel",
            header: "Avail",
            show: true,
            checked: true,
            fieldDataType: "qty",
        },
        {
            field: "baseprice",
            header: "Base Price",
            show: true,
            checked: true,
            fieldDataType: "currency",
        },
        {
            field: "price",
            header: "Sale Price",
            show: true,
            checked: true,
            fieldDataType: "currency",
        },
        {
            field: "costPrice",
            header: "Cost Price",
            show: true,
            checked: true,
            fieldDataType: "currency",
        },
        {
            field: "locationId",
            header: "Loc. ID",
            show: true,
            checked: true,
            fieldDataType: "string",
        },
    ];
    pageNumber = 1;
    pageSize = 15;
    productGlobalSearch = "";
    totalRecord = 0;
    allProducts: IProduct[] = [];
    noProductFoundOrLoadingText;
    productChannels = [];
    selectedChannel;
    allLocations = [];
    selectedLocation;
    tableShowMore: number[] = [15, 30, 50, 100];
    first: number = 0;
    // fraction digits
    fractionDigits: number = 0;
    qtyFractionDigits: number = 0;

    //filter
    selectedFilterBy;
    filterGroup: IReportsFilterModel[] = [];
    filterBy = [];
    @ViewChild('op') op: any;


    constructor(
        private service: ProductSelectionService,
        private productDataService: ProductDataService,
        private importService: ImportserialService
    ) {}

    ngOnInit() {
        this.getFractionDigits();
        this.getQtyDecimalDigits();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.initDefault();
        if (this.displayProductSelectionModal) {
            if (this.isVisibleLocation) {
                this.getAllWarehouse();
            }
            this.getProductsChannels("Product Type");
        }
        if (changes.selectedProductsList && changes.selectedProductsList.currentValue) {
            this.selectedProductsList = changes.selectedProductsList.currentValue;
            // console.log('this.selectedProductsList ==>>', this.selectedProductsList);
        }
    }

    initDefault() {
        this.selectedLocation = null;
        this.pageNumber = 1;
        this.pageSize = 15;
        this.productGlobalSearch = "";
    }

    getProducts() {
        this.noProductFoundOrLoadingText = "Loading...";
        let locationId = this.isVisibleLocation ? (this.selectedLocation ? this.selectedLocation.id : 0) : this.selectedLocationId;
        let accId = this.pricebookConfig ? this.selectedAccountId : 0;
        this.service
            .getWarehouseWiseProduct(this.selectedChannel?.id, this.pageNumber, this.pageSize, this.productGlobalSearch, locationId, accId)
            .then((products) => {
                let { inventory, headers } = products;
                inventory = inventory == null ? [] : inventory;
                headers = headers == null ? [] : headers;
                this.totalRecord = headers["TotalCount"];
                this.allProducts = this.productDataService.prepareProductsList(inventory);
            })
            .finally(() => {
                this.noProductFoundOrLoadingText = "No Products found.";
            });
    }

    getProductsChannels(name) {
        this.service.getAllProductsChannel(name).subscribe((channels) => {
            const config = JSON.parse(channels.configurationDetails[0].configJSONValue);
            if (this.moduleName == "Bundle") {
                const filteredData = config.filter((c) => c.name != ObjectNames.CHANNEL_BUNDLE);
                this.productChannels = filteredData;
            } else if (this.moduleName == "Kit") {
                const filteredData = config.filter((c) => c.name != ObjectNames.CHANNEL_KIT);
                this.productChannels = filteredData;
            } else {
                this.productChannels = config;
            }
            this.selectedChannel = this.productChannels[0];
            if (!this.isVisibleLocation) {
                this.getProducts();
            }
        });
    }
    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .subscribe({
                next: (value) => {
                    if(value){
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }
    getQtyDecimalDigits() {
        this.importService
            .getQtyDecimalValue()
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }

    getAllWarehouse() {
        this.service.getAllLocations("0", "0", "").subscribe((wHouse) => {
            let arr = [];
            for (let l of wHouse) {
                let eachWHouse = {
                    id: l.id,
                    name: l.locationId + " - " + l.name,
                    locationId: l.locationId,
                    contactName: l.contactPersonName,
                    state: l.state,
                    country: l.country,
                    IsDefault: l.isDefault == true ? "Yes" : "No",
                    qty: l.qtyInStock,
                    statusId: l.statusId,
                };
                arr.push(eachWHouse);
            }
            this.allLocations = JSON.parse(JSON.stringify(arr));
            if (this.type == "CREATE") {
                this.allLocations = this.allLocations.filter((l) => l.statusId == 1);
            }
            if (this.moduleName == SOChannel.ESTIMATES) {
                this.selectedLocation = this.allLocations.filter((l) => l.IsDefault?.toLowerCase() == "yes")[0];
                this.selectedLocationId = this.selectedLocation?.id;
                this.getProducts();
            }
            if (this.moduleName == SOChannel.OPPORTUNITY || this.selectDefaultLocation) {
                if (this.selectedLocationId > 0) {
                    this.selectedLocation = this.allLocations.find((l) => l.id == this.selectedLocationId) ?? null;
                } else {
                    this.selectedLocation = this.allLocations.filter((l) => l.IsDefault?.toLowerCase() == "yes")[0];
                    this.selectedLocationId = this.selectedLocationId > 0 ? this.selectedLocationId : this.selectedLocation?.id;
                }
                this.getProducts();
            }
        });
    }

    onRowUnselect(event){
        this.selectedProductsList = this.selectedProductsList?.filter(product => product.id != event?.data?.id);
    }

    onChannelChange() {
        this.productGlobalSearch = "";
        this.getProducts();
    }

    onLocationChange() {
        this.getProducts();
    }

    onPageChange(event) {
        this.pageNumber = event.first / event.rows + 1;
        this.pageSize = event.rows;
        this.first = event.first;
        this.productGlobalSearch = "";
        this.getProducts();
    }

    onGlobalSearchProduct() {
        this.pageNumber = 1;
        this.getProducts();
    }

    addProduct() {
        if (this.isVisibleLocation) {
            this.onLocationSelect.emit(this.selectedLocation);
        }
        this.onProductAddComplete.emit(this.selectedProductsList);
    }

    cancelModal() {
        this.displayProductSelectionModal = false;
        this.onCancelClicked.emit({});
    }

    //filter
    editFilter(s){

    }
    removeFilter(s,i){

    }
    modifyColumnFilterBy(){

    }
    closePanel(): void {
        this.selectedFilterBy = null;
        this.op.hide();
    }
    changeFilterOptions(){

    }
    applyFilter(){

    }
    saveFilter(){
        
    }
}
